import {
  background,
  Box,
  Button,
  Center,
  Container,
  Divider,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import MobileNoForm from "./MobileNoForm";
import OTPform from "./OTPForm";
import footer from "../../Components/Footer/Footer"
import { useNavigate } from 'react-router-dom';


const Signin = ({ issignedin }) => {
  const [register, setRegister] = useState(false);
  const navigate = useNavigate(); 
  
  const toggleMobileAuthenticate = (userid, isSeller) => {
    localStorage.setItem("userDetails", JSON.stringify({userid:userid}));
    if (isSeller){
      localStorage.setItem("isSeller",true);
      localStorage.setItem("isLoggedIn", true);
      issignedin("Seller");
    } else{
      issignedin("User");
      localStorage.setItem("isLoggedIn", true);
    }
  };

  const onSetRegisrer = () => {
    setRegister(!register);
  }

  return (
    <Flex
      // backgroundImage={"LINK"}
      bg={"rgb(236, 236, 236)"}
      // background={"linear-gradient(90deg, rgba(219,48,25,0.9669117647058824) 35%, rgba(228,51,9,0.7960434173669468) 50%, rgba(255,201,0,0.9697128851540616) 100%)"}
      height="150vh"
      flexDirection={"column"}
      alignItems="center"
    >
      <Container
        bg={"white"}
        centerContents
        borderRadius={"16px"}
        width="80%"
        maxW="4xl"
        margin={"60px"}
        mb='20px'
      >
        <Flex>
          <Flex alignItems="center">
            <Image
              width="100%"
              maxW={"488px"}
              height={"400px"}
              src="https://i.ibb.co/P9rk4vH/signin-banner.gif"
            />
           
          </Flex>
          <Box>
            {(register) 
            ?<OTPform />
            :<MobileNoForm toggleMobileAuthenticate={toggleMobileAuthenticate} />
            }
            {(register) 
            ?<Container centerContent mb={"1px"} onClick={onSetRegisrer}>
            <Button mt="24px" bg={'#5e17eb'} color="white" fontSize="14px" paddingBlock={"10px"}
          height="41px"
          width={"86%"} _hover={{ background: 'green'}} >
            LOGIN
            </Button>
            </Container>
             
            :<Container centerContent mb={"10px"} onClick={onSetRegisrer}>
              <Button mt="24px" bg={'#5e17eb'} color="white" fontSize="14px" paddingBlock={"10px"}
          height="41px"
          width={"86%"} _hover={{ background: 'green'}}>
              Register
              </Button>
             </Container>
            }
          </Box>
        </Flex>
      </Container>
       
       
      <Container fontSize={"12px"} centerContent mb={"10px"} bg={"white"} centerContents borderRadius={"16px"} width="80%" maxW="4xl" margin={"60px"} height={"40px"}>
        <Text>
          By continuing you agree to our {""}
          <Link color="#5e17ef" onClick={() => navigate("/termsandconditions")}>Terms of service</Link>
        </Text>
        <Text>
          and <Link color="#5e17ef" onClick={() => navigate("/privacypolicy")}>Privacy & Legal Policy</Link>.
        </Text>
      </Container>
  
    </Flex>
  );
};

export default Signin;
